import { action, thunk, computed } from 'easy-peasy'

const conversation = {
  
}

export default conversation
